export const UserQualificationsDisplayType = {
  All: 1,
  Contract: 2,
} as const
